@if (configService.headerConfig(); as headerConfig) {
  <pa-header
    [headerConfig]="headerConfig"
    (logout)="onLogout()"
    (workspaceClick)="onWorkspaceClick()"
    (cookiePreferencesClick)="onCookiePreferencesClick()"
  ></pa-header>
}

<!-- Breadcrumb Second Header - Global Navigation (only when authenticated) -->
@if (authService.user()) {
  <div class="breadcrumb-second-header">
    <app-breadcrumb></app-breadcrumb>
  </div>
}

<!-- Global Workspace Sidebar - Story 2.8 (only when authenticated) -->
@if (authService.user()) {
  <app-workspace-sidebar></app-workspace-sidebar>
}

<!-- Global Progress Bar - Positioned below breadcrumb header -->
@if (loaderService.hasLoadingItems()) {
  <mat-progress-bar
    class="global-progress-bar"
    mode="indeterminate"
  ></mat-progress-bar>
}

<main
  #appContent
  class="app-content"
  [class.has-sidebar]="showSidebarSpacing()"
  [style.margin-left]="sidebarMargin()"
>
  <router-outlet></router-outlet>
</main>

<!-- Feedback Button - Displayed on all authenticated pages -->
@if (authService.user()) {
  <app-feedback-button></app-feedback-button>
}

<!-- Cookie Consent Banner - Story 6.2 -->
<app-cookie-consent-banner></app-cookie-consent-banner>

@if (configService.footerConfig(); as footerConfig) {
  <pa-footer [footerConfig]="footerConfig"></pa-footer>
}
